import { render, staticRenderFns } from "./RadiosForm.vue?vue&type=template&id=9da7fbde"
import script from "./RadiosForm.vue?vue&type=script&lang=js"
export * from "./RadiosForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports